<style lang="scss" scoped>
.testimonials {
    position: relative;
    height: 480px;
    width: 1440px;
    .testimonial {
        border-radius: 50%;
        position: absolute;
        transition: all 0.15s ease-in-out;
        cursor: pointer;
        &:hover,
        &.active {
            border: 5px solid #ffffff;
        }
        &.testimonial_0 {
            height: 114px;
            width: 114px;
            opacity: 0.5;
            bottom: 0;
            left: -80px;
        }
        &.testimonial_1 {
            height: 214px;
            width: 214px;
            top: 80px;
            left: -10px;
        }
        &.testimonial_2 {
            height: 100px;
            width: 100px;
            opacity: 0.5;
            bottom: 64px;
            left: 184px;
        }
        &.testimonial_3 {
            left: 314px;
            height: 78px;
            width: 78px;
            opacity: 0.5;
            top: 28px;
        }
        &.testimonial_4 {
            left: 353px;
            height: 142px;
            width: 142px;
            bottom: 74px;
        }
        &.testimonial_5 {
            left: 443px;
            height: 255px;
            width: 255px;
            top: 0;
        }
        &.testimonial_6 {
            left: 636px;
            height: 98px;
            width: 98px;
            bottom: 96px;
        }
        &.testimonial_7 {
            left: 815px;
            height: 116px;
            width: 116px;
            top: 30px;
        }
        &.testimonial_8 {
            left: 924px;
            height: 98px;
            width: 98px;
            opacity: 0.5;
            bottom: 41px;
        }
        &.testimonial_9 {
            left: 1043px;
            height: 188px;
            width: 188px;
            top: 24px;
        }
        &.testimonial_10 {
            left: 1109px;
            height: 114px;
            width: 114px;
            opacity: 0.5;
            bottom: 74px;
        }
        &.testimonial_11 {
            left: 1269px;
            height: 114px;
            width: 114px;
            bottom: 181px;
        }
        &.testimonial_12 {
            left: 1313px;
            height: 72px;
            width: 72px;
            opacity: 0.5;
            top: 46px;
        }
    }
}
.preview {
    max-width: 744px;
}
</style>

<template>
    <section>
        <div class="flex justify-center mb-20">
            <div class="testimonials">
                <div v-for="(testimonial, key) in testimonials" :key="`testimonial_${key}`" @click="active = key" class="testimonial" :class="[`testimonial_${key}`, { active: active === key }]" :style="{ backgroundImage: `url(${testimonial.src})` }"></div>
            </div>
        </div>
        <div class="flex justify-center">
            <div class="preview lg:text-center">
                <h3 class="mb-24 text-title-md font-extraBold">{{ activeTestimonial.title }}</h3>
                <div class="mb-24"></div>
                <p class="mb-40 text-gray text-18 px-98">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.
                </p>
                <button type="button" class="text-button text-dark rounded-button border border-white bg-white font-bold px-40 py-24 transition-colors hover:bg-transparent hover:text-white">Start met stoppen</button>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        data: {
            required: true,
            default: () => ({
                id: "",
                title: "",
                content: ""
            })
        }
    },
    data: () => ({
        testimonials: [
            { src: "https://picsum.photos/200/200", title: "Gestopt met roken dankzij Start to Stop", rate: 4, description: "", slug: "" },
            { src: "https://picsum.photos/201/201", title: "Gestopt met roken dankzij Start to Stop", rate: 3, description: "", slug: "" },
            { src: "https://picsum.photos/202/202", title: "Gestopt met roken dankzij Start to Stop", rate: 4, description: "", slug: "" },
            { src: "https://picsum.photos/203/203", title: "Gestopt met roken dankzij Start to Stop", rate: 5, description: "", slug: "" },
            { src: "https://picsum.photos/204/204", title: "Gestopt met roken dankzij Start to Stop", rate: 3, description: "", slug: "" },
            { src: "https://picsum.photos/205/205", title: "Gestopt met roken dankzij Start to Stop", rate: 4, description: "", slug: "" },
            { src: "https://picsum.photos/206/206", title: "Gestopt met roken dankzij Start to Stop", rate: 4, description: "", slug: "" },
            { src: "https://picsum.photos/207/207", title: "Gestopt met roken dankzij Start to Stop", rate: 3, description: "", slug: "" },
            { src: "https://picsum.photos/208/208", title: "Gestopt met roken dankzij Start to Stop", rate: 5, description: "", slug: "" },
            { src: "https://picsum.photos/209/209", title: "Gestopt met roken dankzij Start to Stop", rate: 3, description: "", slug: "" },
            { src: "https://picsum.photos/210/210", title: "Gestopt met roken dankzij Start to Stop", rate: 3, description: "", slug: "" },
            { src: "https://picsum.photos/211/211", title: "Gestopt met roken dankzij Start to Stop", rate: 4, description: "", slug: "" },
            { src: "https://picsum.photos/212/212", title: "Gestopt met roken dankzij Start to Stop", rate: 5, description: "", slug: "" }
        ],
        active: 5
    }),

    computed: {
        localTestimonials() {
            return this.testimonials.slice(0, 13);
        },
        activeTestimonial() {
            return this.testimonials[this.active];
        }
    }
};
</script>
